import {
  Box,
  Flex,
  Text,
  Link,
  Input,
  Stack,
  Select,
  Button,
  HStack,
  Heading,
  useToast,
  FormLabel,
  InputGroup,
  FormControl,
  InputRightElement,
  useColorModeValue,
} from "@chakra-ui/react";
import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";

const Register = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [password, setPassword] = useState(null);
  const [mobile, setMobile] = useState(null);
  const [age, setAge] = useState(null);
  const [address, setAddress] = useState("");
  const [gender, setGender] = useState("");
  const [occupation, setOccupation] = useState("");

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    validateEmail(value);
  };

  const validateEmail = () => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    setIsValidEmail(emailPattern.test(email));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let finalName = firstName + " " + lastName;

    let userRegisterObj = {
      name: finalName,
      email: email,
      password: password,
      mobile: Number(mobile),
      age: Number(age),
      address: address,
      gender: gender,
      occupation: occupation,
    };

    if (
      finalName === "" ||
      email === "" ||
      password === "" ||
      mobile === "" ||
      age === "" ||
      address === "" ||
      gender === "" ||
      occupation === ""
    ) {
      toast({
        title: "All fields required to fulfill",
        status: "warning",
        duration: 2000,
        isClosable: true,
      });
    } else if (mobile.length !== 10) {
      toast({
        title: "Mobile Number must be 10 digits",
        status: "warning",
        duration: 2000,
        isClosable: true,
      });
    } else if (!isValidEmail) {
      toast({
        title: "Invalid email",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    } else {
      axios
        .post("https://user-auth-wfn4.onrender.com/users", userRegisterObj)
        .then((res) => {
          toast({
            title: "Hurray, Register Successfully ....",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
          navigate("/");
        })
        .catch((err) => {
          toast({
            title: "Data Post Error",
            status: "error",
            duration: 2000,
            isClosable: true,
          });
        });
    }
  };

  return (
    <Flex
      minH={"100vh"}
      align={"center"}
      justify={"center"}
      bg={useColorModeValue("gray.50", "gray.800")}
    >
      <Stack spacing={8} w={{ base: "90%", md: "40%" }} py={12} px={6}>
        <Stack align={"center"}>
          <Heading
            fontSize={"4xl"}
            textAlign={"center"}
            color={"saddlebrown "}
            textDecoration={"underline"}
          >
            Register
          </Heading>
        </Stack>

        <Box
          rounded={"lg"}
          bg={useColorModeValue("white", "gray.700")}
          boxShadow={"lg"}
          p={8}
        >
          <Stack spacing={4}>
            {/* Name */}
            <HStack>
              <Box>
                <FormControl id="firstName" isRequired>
                  <FormLabel>First Name</FormLabel>
                  <Input
                    type="text"
                    name="firstname"
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </FormControl>
              </Box>

              <Box>
                <FormControl id="lastName">
                  <FormLabel>Last Name</FormLabel>
                  <Input
                    type="text"
                    name="lastname"
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </FormControl>
              </Box>
            </HStack>

            {/* Email */}
            <FormControl id="email" isRequired>
              <FormLabel>Email address</FormLabel>
              <Input
                type="email"
                name="email"
                autoComplete="off"
                onChange={handleEmailChange}
              />
            </FormControl>

            {/* Password */}
            <FormControl id="password" isRequired>
              <FormLabel>Password</FormLabel>
              <InputGroup>
                <Input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  autoComplete="off"
                  onChange={(e) => setPassword(e.target.value)}
                />
                <InputRightElement h={"full"}>
                  <Button
                    variant={"ghost"}
                    onClick={() =>
                      setShowPassword((showPassword) => !showPassword)
                    }
                  >
                    {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                  </Button>
                </InputRightElement>
              </InputGroup>
            </FormControl>

            {/* Mobile Number */}
            <FormControl id="mobile" isRequired>
              <FormLabel>Mobile</FormLabel>
              <Input
                type="tel"
                name="mobile"
                onChange={(e) => setMobile(e.target.value)}
              />
            </FormControl>

            {/* Age */}
            <FormControl id="age" isRequired>
              <FormLabel>Age</FormLabel>
              <Input
                type="number"
                name="age"
                onChange={(e) => setAge(e.target.value)}
              />
            </FormControl>

            {/* Address */}
            <FormControl id="address" isRequired>
              <FormLabel>Address</FormLabel>
              <Input
                type="text"
                name="address"
                onChange={(e) => setAddress(e.target.value)}
              />
            </FormControl>

            {/* Gender */}
            <FormControl id="gender" isRequired>
              <FormLabel>Gender</FormLabel>

              <HStack>
                <input
                  type="radio"
                  name="gender"
                  value="Male"
                  onChange={(e) => setGender(e.target.value)}
                />
                <Text>Male</Text>
                <input
                  type="radio"
                  name="gender"
                  value="Female"
                  onChange={(e) => setGender(e.target.value)}
                />
                <Text>Female</Text>
              </HStack>
            </FormControl>

            {/* Occupation */}
            <FormControl id="occupation" isRequired>
              <FormLabel>Occupation</FormLabel>
              <Select
                placeholder="Select Occupation"
                onChange={(e) => setOccupation(e.target.value)}
              >
                <option value="Teacher">Teacher</option>
                <option value="Student">Student</option>
                <option value="Businessman">Businessman</option>
              </Select>
            </FormControl>

            <Stack spacing={10} pt={2}>
              <Button
                loadingText="Submitting"
                size="lg"
                bg={"blue.400"}
                color={"white"}
                _hover={{
                  bg: "blue.500",
                }}
                onClick={handleSubmit}
              >
                Register
              </Button>
            </Stack>
            <Stack pt={6}>
              <Text align={"center"}>
                Already a user?{" "}
                <Link color={"blue.400"} onClick={() => navigate("/")}>
                  Login
                </Link>
              </Text>
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </Flex>
  );
};

export default Register;
